export function formatPhoneNumber(number: string, intlPhone?: boolean): string {
  // regex for local shipping address phone number
  const regexLocal = /[^0-9]/g;
  // regex for local or international billing address phone number
  // eslint-disable-next-line no-useless-escape
  const regexIntl = /[^\+\(\)\ \-0-9]/g;
  const input = number.replace(intlPhone ? regexIntl : regexLocal, '');
  let output = '';
  if (!intlPhone) {
    const area = input.substr(0, 3);
    const pre = input.substr(3, 3);
    const tel = input.substr(6, 4);
    if (area.length === 3 && pre.length === 3 && tel) {
      output = `(${area}) ${pre}-${tel}`;
    } else if (area.length === 3 && pre) {
      output = `(${area}) ${pre}`;
    } else if (area) {
      output = `(${area}`;
    }
    return output;
  }
  return input;
}

export const formatPhoneNumberUS = (value: string): string => {
  const number = value?.replace(/[^0-9]+/g, '');
  if (!number) return '';
  if (number.length > 0 && number.length <= 3) {
    return `(${number.slice(0, 3)}`;
  }
  if (number.length > 3 && number.length <= 6) {
    return `(${number.slice(0, 3)}) ${number.slice(3)}`;
  }
  return `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6, 10)}`;
};
